import CtaBand from "@/components/feature/CtaBand";
import Hero from "@/pages/home/components/Hero";
import HomeIntro from "@/pages/home/components/HomeIntro";
import HomeContactStrip from "@/pages/home/components/HomeContactStrip";

export default function Home() {
  return (
    <>
      <Hero />
      <HomeIntro />
      <HomeContactStrip />
      <CtaBand />
    </>
  );
}